export const Events = {
  NETWORK_REQUEST: "Network Request",
  NETWORK_ERROR: "Network Error",
  LINK_CLICK: "Link Clicked",
  BUTTON_CLICK: "Button Clicked",
  SHORTCUT_USE: "Shortcut Used",
  FORGE_SETTINGS_CHANGE: "Forge Settings Changed",
  // Forging
  FORGE_CLICK: "Forge Clicked",
  FORGE_START: "Forge Start",
  FORGE_ERROR: "Forge Error",
  // Styles
  STYLE_CREATE: "Style Created",
  STYLE_CREATE_DRAFT: "Style Draft Created",
  STYLE_CREATE_DRAFT_FROM_UPLOAD: "Style Created from Newly Uploaded Model",
  STYLE_CREATE_DRAFT_FROM_MODEL: "Style Created from Existing Model in Drive",
  STYLE_DELETE_FROM_STUDIO: "Style Deleted from Studio",
  STYLE_CREATE_TRIGGER_ERROR: "Style Creation Cannot Start",
  STYLE_DUPLICATE_FROM_STUDIO: "Style Duplicated from Studio",
  STYLE_EDIT_FROM_STUDIO: "Navigated to Style Edit View from Studio",
  STYLE_FORGE_FROM_STUDIO: "Navigated to Forge With Style from Studio",
  STYLE_LOCATE_FROM_STUDIO: "Navigated to Style in Drive from Studio",
  STYLE_IMPORTED_FROM_STUDIO: "Style Imported from Studio",
  STYLE_UNLINKED_FROM_STUDIO: "Style Unlinked from Studio",
  STYLE_CANCEL_TRAINING: "Style Training Canceled",
  STUDIO_UPGRADE: "Upgrade to Pro Clicked from Studio",
  // Sessions
  SESSION_CREATE: "Session Created",
  SESSION_OPEN: "Session Opened",
  SESSION_ARCHIVE: "Session Archived",
  SESSION_DELETE: "Session Deleted",
  SESSION_RENAMED_HOMEPAGE: "Session Renamed from Homepage",
  SESSION_RENAMED_BREADCRUMBS: "Session Renamed from Session Breadcrumbs",
  SESSION_FILES_LIKED: "Session Files Liked",
  SESSION_FILES_SAVED_TO_DRIVE: "Session Files Saved to Drive",
  SESSIONS_PREVIEW_FILE: "Session Preview File",
  // Homepage
  CLICK_UPGRADE_BANNER_PRO: "Homepage Upgrade to Pro Banner Clicked",
  CLICK_UPGRADE_BANNER_STUDIO: "Homepage Upgrade to Studio Banner Clicked",
  CLICK_UPGRADE_BANNER_ENTERPRISE:
    "Homepage Upgrade to Enterprise Banner Clicked",
  HOMEPAGE_NAVIGATION_CARD_CLICKED: "Homepage Navigation Card Clicked",
};
